import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    平台导航: [
      { label: '首页', to: '/' },
      { label: '西瓜视频', to: '/category/xigua' },
      { label: '糖豆视频', to: '/category/tangdou' },
      { label: '小蓝视频', to: '/category/xiaolan' },
      { label: '芒果视频', to: '/category/mangguo' },
      { label: '丝瓜视频', to: '/category/sigua' },
      { label: '蓝莓视频', to: '/category/lanmei' },
    ],
    关于我们: [
      { label: '品牌介绍', to: '/about' },
      { label: '联系方式', to: '/about#contact' },
      { label: '服务条款', to: '/about' },
      { label: '隐私政策', to: '/about' },
    ],
    热门推荐: [
      { label: '最新剧集', to: '/category/sigua' },
      { label: '热门综艺', to: '/category/mangguo' },
      { label: '搞笑视频', to: '/category/xigua' },
      { label: '纪录片', to: '/category/lanmei' },
      { label: '科技频道', to: '/category/xiaolan' },
      { label: '健康养生', to: '/category/tangdou' },
    ],
  };

  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </span>
              <span className="text-xl font-bold font-heading text-background-50">茄子视频</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              聚合在线影视平台，汇集西瓜视频、糖豆视频、小蓝视频、芒果视频、丝瓜视频、蓝莓视频等优质内容，提供高清免费在线观看服务。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} 茄子视频 qiezi.video - 版权所有 | 高清免费在线影视平台
          </p>
          <p className="text-xs text-background-50/40">
            <a href="#" className="hover:text-background-50/60 transition-colors cursor-pointer">服务条款</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-background-50/60 transition-colors cursor-pointer">隐私政策</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-background-50/60 transition-colors cursor-pointer">版权声明</a>
          </p>
        </div>
      </div>
    </footer>
  );
}